<template functional>
  <div>
    <span
      v-if="
        $options.formatDate(props.row[props.column]) && props.column != 'Date'
      "
      :style="{
        color: $options.colorDate(props.row[props.column]) ? 'inherit' : 'red'
      }"
    >
      <i class="el-icon-time"></i>
      {{ $options.setFormatDate(props) }}
    </span>
    <span
      v-if="props.column == 'Date'"
      :style="{
        color: $options.colorHour(props.row[props.column]) ? 'blue' : 'orange'
      }"
    >
      <i class="el-icon-time"></i>
      {{ $options.setFormatDate(props) }}
    </span>
  </div>
</template>

<script>
import { formatDate } from "@/utils";
export default {
  name: "DatetimeFormatterColor",
  formatDate,
  setFormatDate(props) {
    const date = props.row[props.column];
    if (props.column == "Date") {
      return formatDate(date, "h:mm: a");
    }

    if (props["onlyDate"]) {
      return formatDate(date, "DD/MM/YYYY");
    }

    return formatDate(date, "DD/MM/YYYY");
  },
  colorDate(date) {
    let currentDate = new Date(Date.now());
    currentDate = currentDate.toISOString();

    if (date < currentDate) {
      return false;
    } else if (date > currentDate) {
      return true;
    }
  },
  colorHour(date) {
    var hour = new Date(date);
    if (hour.getHours() <= 12) {
      return false;
    } else if (hour.getHours() > 12) {
      return true;
    }
  }
};
</script>
